import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import DeliverablesSection from './components/DeliverablesSection';
import FitSection from './components/FitSection';
import RequestFormSection from './components/RequestFormSection';
import FaqSection from './components/FaqSection';

export default function AlmaDemandPage() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <HowItWorksSection />
        <DeliverablesSection />
        <FitSection />
        <RequestFormSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}
